import { mapState, mapActions,mapGetters } from 'vuex'
import HttpFactory from '@/mixins/http.factory';
export default {
	mixins:[HttpFactory],
	data () {
		return {
			columnDefs:[],
			data:null,
			//auth only
			//baseUrl:config.baseUrl,
			//loading:false,
			isFormValidated:false,
			disableValidateBtn:true,
			//userMsg:{type:'info',list:[]},
			auth:{}
		}
	},
	created () {
		this.init();
	},
	computed:{
		//...mapGetters(['zendesk/getZendeskInfo']),
		//...mapState('zendesk',['zdMetadata']),
		...mapState('zendesk',['zendeskInfo']),
		...mapState('zdGithub',['appData'])
	},
	methods:{
		async init(){
			let _self=this;
			await _self.getAppData();
			_self.fn().registerModalInstance();
		},
		async getAppData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			try{

				//await this.$store.dispatch('zendesk/getZendeskMetadata');
				await this.$store.dispatch('zendesk/getZendeskInfo')
				
				_self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;
				_self.auth.hdEmail=_self.zendeskInfo.user.email;
				
				await this.$store.dispatch('zdGithub/getAppData',{auth:_self.zendeskInfo.credentials});
				_self.data=_self.appData;
			}
			catch(ex){
				_self.commonErrorMsgDisp(ex);
			}
			_self.fn().showLoader(false);
			_self.setAppHeight();
			
		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }
            
            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            	&& _self.auth.githubToken) {
                return true;
            }

            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('Zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('Zendesk Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('Zendesk Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('Zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('Zendesk Email is  invalid.');
			}
            // if (!_self.auth.githubUrl) {
            //     _self.userMsg.list.push('Github Url is  required.');
            // }else if(!_self.validUrl(_self.auth.githubUrl)){
            //     _self.userMsg.list.push('Github Url is invalid.');
            // }
            if (!_self.auth.githubToken) {
                _self.userMsg.list.push('Github Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self=this;
            if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.zendeskInfo.credentials.appId;
			_self.auth.installationId=_self.zendeskInfo.credentials.installationId; 
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				url:'authenticate',
                headers: {'Content-Type': 'application/json'}
            };
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    _self.init();
					//window.location.reload();
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
		authenticate_modal(){
			let _self=this;
			var size={ width: '80vw',height: '100vh'};
			let action='authenticate';
			
			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.githubUrl)}`
			}
			_self.fn().create_zendesk_modal(action,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		configure(){
			let _self=this;
			var size = { width: '80vw', height: '100vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.fn().create_zendesk_modal(`configure/${zdTicketId}`,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		createIssue(){
			let _self=this;
			var size = { width: '80vw', height: '100vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			let cPath='';
			console.log('Cust Github Org Is ',_self.fn().getGithubOrg(_self.appData.userInfo.githubUrl));
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getGithubOrg(_self.appData.userInfo.githubUrl)){
					case 'devopsintegrationio1':
						cPath='custom/devopsintegrationio/';
					break;
					case 'Zapper-fi':
						cPath='custom/zapper-fi/';
						break; 
					case 'normalyze':
						cPath='custom/normalyze/';
					break;
				}
			}
			_self.fn().create_zendesk_modal(cPath+`create-issue/${zdTicketId}`,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		notifyIssue(){
			let _self=this;
			var size = { width: '50vw', height: '100vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.fn().create_zendesk_modal(`notify-issue/${zdTicketId}`,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		linkIssue(){
			let _self=this;
			var size = { width: '40vw', height: '45vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.fn().create_zendesk_modal(`link-issue/${zdTicketId}`,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		linkedTickets(){
			let _self=this;
			var size = { width: '80vw', height: '60vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.fn().create_zendesk_modal(`linked-tickets/${zdTicketId}`,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		enableSyncing(){
			let _self=this;
			var size = { width: '50vw', height: '50vh' };
			_self.fn().create_zendesk_modal('enable-syncing',size,null,null,null,function(){
				//_self.getAppData();
			});
		},
		issueLog(linkData){
			let _self=this;
			var size = { width: '80vw', height: '100vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.zendeskInfo.linkData=linkData;
			let triggerInstance=`issue-log-dialog_zd${linkData.hdTicketId}_wd${linkData.issueId}`;
			let action=`issue-log/${zdTicketId}?hdTicketId=${linkData.hdTicketId}&issueId=${linkData.issueId}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,null,_self.zendeskInfo,function(){
				_self.getAppData();
			});
		},
		resetCacheConfirm(){
			let _self=this;
			let linkData={hdTicketId:_self.zendeskInfo.ticket.id};
			var size = { width: '30vw', height: '8vw' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.zendeskInfo.linkData=linkData;
			_self.zendeskInfo.msg=`Do you want to reset the cache?`
			let triggerInstance=`confirm-dialog_zd${linkData.hdTicketId}_cacheReset`;
			let cbInstance=`remove-confirm-dialog_zd${linkData.hdTicketId}_cacheReset`;
			let action=`confirm-dialog/${zdTicketId}?hdTicketId=${linkData.hdTicketId}&cacheReset=${linkData.hdTicketId}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,cbInstance,_self.zendeskInfo,function(response){
				if(response.Success && response.type=='confirmed'){
					_self.resetCache(linkData,_self.getAppData);
				}else{
					_self.getAppData();
				}
				
			});
		},
		resetCache(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth:_self.zendeskInfo.credentials
			};
			let url=`reset/cache/${linkData.hdTicketId}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		removeConfirm(linkData){
			let _self=this;
			var size={ width: '30vw',height: '8vw'};
			_self.zendeskInfo.linkData=linkData;
			_self.zendeskInfo.msg=`Do you want to unlink Issue: #${linkData.issueId}?`
			let triggerInstance=`confirm-dialog_zd${linkData.hdTicketId}_wd${linkData.issueId}`;
			let cbInstance=`remove-confirm-dialog_zd${linkData.hdTicketId}_wd${linkData.issueId}`;
			let action=`confirm-dialog?hdTicketId=${linkData.hdTicketId}&issueId=${linkData.issueId}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,cbInstance,_self.zendeskInfo,function(response){
				if(response.Success && response.type=='confirmed'){
					_self.unlinkIssue(linkData,_self.getAppData);
				}else{
					_self.getAppData();
				}
				
			});
		},
		unlinkIssue(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth:_self.zendeskInfo.credentials,
				repo: linkData.repository,
				user:_self.zendeskInfo.user
			};
			let url=`zendesk/unlink/${linkData.hdTicketId}/${linkData.issueId}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		expandCollapse(linkedIssue,lnkInd){
			let _self=this;
			for(var i in _self.data.linkedTickets)
				if(i!=lnkInd) _self.data.linkedTickets[i].show = false;
			linkedIssue.show=!linkedIssue.show;
		},
		setAppHeight:function(){
			let _self=this;
			if(!_self.data) return;
            var linkedTickets=_self.data.linkedTickets;
            var height=170;
            height+=(linkedTickets && linkedTickets.length>0)?(linkedTickets.length*85+230):75;
			//client.instance.resize({ height: `${height}px` });     
			client.invoke('resize', {  height: `${height}px`})   
        },
	},
	components:{}
}

